/**
 * Enums para visualizar de manera mas facil los valores que estan en la base de datos y funciones que mapean a sus correspondientes valores
 */

import api from '../../api/api.js';

/**
 * Char que corresponde al campo tipo_pedido de la base de datos
 */
export const abbreviatedTipoPedido = {
    insumos: 'I',
    cafeteria: 'C',
    refrigerios: 'R',
};

/**
 * Nombre completo del tipo de pedido
 */
export const readableTipoPedido = {
    insumos: 'Insumos',
    cafeteria: 'Cafetería',
    refrigerios: 'Refrigerios',
};

/**
 * Endpoint del select de productos de cada tipo de pedido.
 * La categoria la fija el endpoint en el backend, no viaja como filtro: asi nadie
 * puede pedir los productos de otra categoria cambiando el querystring.
 */
const urlProductosTipoPedido = {
    insumos: api.productos.insumosSelect,
    cafeteria: api.productos.cafeteriaSelect,
    refrigerios: api.productos.refrigeriosSelect
};

/**
 * Endpoint de los pedidos propios de cada tipo de pedido (historial y alta).
 * Igual que con los productos, la categoria la fija la ruta en el backend.
 */
const urlMisPedidosTipoPedido = {
    insumos: api.pedidos.misInsumos,
    cafeteria: api.pedidos.misCafeteria,
    refrigerios: api.pedidos.misRefrigerios
};

/**
 * Classname del icono bootstrap que aparece al lado del titulo correspondiente a su tipo de pedido
 */
export const iconoClassnameTipoPedido = {
    insumos: 'fa fa-cart-plus',
    cafeteria: 'fa fa-coffee',
    refrigerios: 'fa fa-apple'
};

/**
 * Color del icono en HEX correspondiente a su tipo de pedido
 */
export const iconoColorTipoPedido = {
    insumos: '#00BFFF',
    cafeteria: '#D2B48C',
    refrigerios: '#FF6347'
};


/**
 * Para obtener la url del select de productos segun el tipo de pedido
 * @param {string} tipo_pedido - Es un char de abbreviatedTipoPedido
 * @returns {string} - Endpoint correspondiente al tipo de pedido
 */
export const getUrlProductosTipoPedido = (tipo_pedido) => {
    switch (tipo_pedido) {
        case abbreviatedTipoPedido.insumos:
            return urlProductosTipoPedido.insumos;
        case abbreviatedTipoPedido.cafeteria:
            return urlProductosTipoPedido.cafeteria;
        case abbreviatedTipoPedido.refrigerios:
            return urlProductosTipoPedido.refrigerios;
        default:
            return ''; // Nunca deberia llegar aquí
    }
}

/**
 * Para obtener la url de los pedidos propios segun el tipo de pedido
 * @param {string} tipo_pedido - Es un char de abbreviatedTipoPedido
 * @returns {string} - Endpoint correspondiente al tipo de pedido
 */
export const getUrlMisPedidosTipoPedido = (tipo_pedido) => {
    switch (tipo_pedido) {
        case abbreviatedTipoPedido.insumos:
            return urlMisPedidosTipoPedido.insumos;
        case abbreviatedTipoPedido.cafeteria:
            return urlMisPedidosTipoPedido.cafeteria;
        case abbreviatedTipoPedido.refrigerios:
            return urlMisPedidosTipoPedido.refrigerios;
        default:
            return ''; // Nunca deberia llegar aquí
    }
}

/**
 * Para obtener el classname del icono bootstrap segun el tipo de pedido
 * @param {string} tipo_pedido - Es un char de abbreviatedTipoPedido
 * @return {string} - Classname bootstrap de un icono
 */
export const getIconoClassnameTipoPedido = (tipo_pedido) => {
    switch (tipo_pedido) {
        case abbreviatedTipoPedido.insumos:
            return iconoClassnameTipoPedido.insumos;
        case abbreviatedTipoPedido.cafeteria:
            return iconoClassnameTipoPedido.cafeteria;
        case abbreviatedTipoPedido.refrigerios:
            return iconoClassnameTipoPedido.refrigerios;
        default:
            return ''; // Nunca deberia llegar aquí
    }
}

/**
 * Para obtener el color del icono segun el tipo de pedido
 * @param {string} tipo_pedido - Es un char de abbreviatedTipoPedido
 * @return {string} - Classname bootstrap de un icono
 */
export const getIconoColorTipoPedido = (tipo_pedido) => {
    switch (tipo_pedido) {
        case abbreviatedTipoPedido.insumos:
            return iconoColorTipoPedido.insumos;
        case abbreviatedTipoPedido.cafeteria:
            return iconoColorTipoPedido.cafeteria;
        case abbreviatedTipoPedido.refrigerios:
            return iconoColorTipoPedido.refrigerios;
        default:
            return ''; // Nunca deberia llegar aquí
    }
}

/**
 * Para obtener el nombre del tipo de pedido segun el tipo de pedido
 * @param {string} tipo_pedido - Es un char de abbreviatedTipoPedido
 * @return {string} - Nombre del tipo de pedido
 */
export const getReadableTipoPedido = (tipo_pedido) => {
    switch (tipo_pedido) {
        case abbreviatedTipoPedido.insumos:
            return readableTipoPedido.insumos;
        case abbreviatedTipoPedido.cafeteria:
            return readableTipoPedido.cafeteria;
        case abbreviatedTipoPedido.refrigerios:
            return readableTipoPedido.refrigerios;
        default:
            return ''; // Nunca deberia llegar aquí
    }
}


// WEBPACK FOOTER //
// ./src/views/PedidosProducto/enums.js